/** @jsxImportSource @emotion/react */

import { FC } from "react";

import {
  CSSRulesResolver,
  useCSSRulesWithTheme,
} from "hooks/useCSSRulesWithTheme";
import { Icon } from "@a_team/ui-components";
import ActionButton from "views/Mission/TeamSpecV2/components/ActionButton";

const getCSSRules: CSSRulesResolver = () => ({
  button: {
    "&[class*=ghost]": {
      border: "none",
      padding: 10,
      margin: 0,
      width: 24,
      height: 24,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      "*, svg, svg *": {
        cursor: "pointer",
      },

      span: {
        lineHeight: 0,
      },
    },

    "&:hover": {
      opacity: 0.5,
    },
  },
});

const CloseButton: FC<{
  onClick: () => void;
  name: string;
  className?: string;
}> = ({ children, onClick, className, name }) => {
  const styles = useCSSRulesWithTheme(getCSSRules);

  return (
    <ActionButton
      css={styles.button}
      className={className}
      name={name}
      onClick={() => onClick()}
      variant="ghost"
    >
      <Icon name="remove" size="lg" />
      {children}
    </ActionButton>
  );
};

export default CloseButton;
